import gql from 'graphql-tag';

export const UPDATE_LOOK_SURVEY_FILTER = gql`
  mutation updateLookSurveyFilter($filter: SurveyFilterInput!, $orderBy: [String]) {
    updateLookSurveyFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
